import { axios, handleError } from '../axios';

export const memberResendPasswordRecoveryCode = () => {
  return new Promise((resolve, reject) => {
    axios
      .post('member/account/forgotten/username/resend')
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
          reject();
        }
      })
      .catch((e) => {
        handleError(e);
        reject();
      });
  });
};
